import axiosInstance from '@/utils/axios';
import { ApiResponse, PaginatedResponse } from '@/types/common_types';
import { CartItemApiData } from '@/types/cart_types';
import { InternalAxiosRequestConfig } from 'axios';

interface ExtendedAxiosRequestConfig extends InternalAxiosRequestConfig {
  skipErrorSnackbar?: boolean;
}

const cartApi = {
  // 장바구니 조회
  getCart: async () => {
    const response = await axiosInstance.get<PaginatedResponse<CartItemApiData>>('/cart/items/');
    return response.data;
  },

  // 장바구니 추가
  addItem: async (trackId?: string) => {
    if (!trackId) {
      return {
        success: false,
        message: 'trackId is required',
      };
    }

    const response = await axiosInstance.post<ApiResponse<CartItemApiData>>('/cart/items/', {
      track_id: Number(trackId),
      quantity: 1,
    }, {
      skipErrorSnackbar: true,
    } as ExtendedAxiosRequestConfig);
    return response.data;
  },

  // 장바구니 삭제
  removeItem: async (cartItemId: string) => {
    const response = await axiosInstance.delete<ApiResponse<{ success: boolean }>>(`/cart/items/${cartItemId}/`);
    return response.data;
  },
};

export { cartApi };
